export default __webpack_public_path__ + "static/ZeroTabletopBianco-2be2ca77f1922919084bab920eb304e8.png";